import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckHistoryNEInfo } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';

import { TConsistencyCheckHistoryInfo } from '@interfaces/cmModule/consistencyCheck';
import { IId } from '@interfaces/common/common';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_HISTORY_INFO } from '@constants/queryKeys';

interface IUseConsistencyCheckHistoryInfoReturned {
	consistencyCheckInfo?: TConsistencyCheckHistoryInfo;
	isLoadingConsistencyCheckHistoryInfo: boolean;
}

const useConsistencyCheckHistoryInfo = ({ id }: IId): IUseConsistencyCheckHistoryInfoReturned => {
	const {
		data,
		isInitialLoading,
		isFetching,
	} = useQuery({
		queryKey: [CONSISTENCY_CHECK_HISTORY_INFO, { id }],
		queryFn: extractQueryParams(getConsistencyCheckHistoryNEInfo),
		enabled: [!!id],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		consistencyCheckInfo: data,
		isLoadingConsistencyCheckHistoryInfo: isInitialLoading || isFetching,
	};
};

export default useConsistencyCheckHistoryInfo;
